import type { SearchFilters } from "@/types/job-search"

export interface SavedSearch {
  id: string
  name: string
  createdAt: string
  filters: SearchFilters
  candidateCount: number
}

export const savedSearches: SavedSearch[] = [
  {
    id: "1",
    name: "Senior React Developers",
    createdAt: "2024-01-15T10:00:00Z",
    candidateCount: 24,
    filters: {
      searchTerm: "Senior React developer with 5+ years experience",
      stageFilter: "all",
      locationFilter: "all",
      matchScoreFilter: "all",
      jobTitle: "Senior React Developer",
      location: "San Francisco, CA",
      yearsOfExperience: "5+",
      industry: "Technology",
      skills: ["React", "JavaScript", "TypeScript", "Node.js"],
    },
  },
  {
    id: "2",
    name: "DevOps Engineers",
    createdAt: "2024-01-10T14:30:00Z",
    candidateCount: 18,
    filters: {
      searchTerm: "DevOps Engineer with Kubernetes and AWS experience",
      stageFilter: "all",
      locationFilter: "all",
      matchScoreFilter: "all",
      jobTitle: "DevOps Engineer",
      location: "Remote",
      yearsOfExperience: "3+",
      industry: "Technology",
      skills: ["Kubernetes", "AWS", "Docker", "CI/CD"],
    },
  },
  {
    id: "3",
    name: "Full Stack Developers",
    createdAt: "2024-01-08T09:15:00Z",
    candidateCount: 31,
    filters: {
      searchTerm: "Full stack developer with Node.js and React",
      stageFilter: "all",
      locationFilter: "all",
      matchScoreFilter: "all",
      jobTitle: "Full Stack Developer",
      location: "New York, NY",
      yearsOfExperience: "2+",
      industry: "Technology",
      skills: ["React", "Node.js", "MongoDB", "Express"],
    },
  },
]

export const getSavedSearchById = (id: string): SavedSearch | undefined => {
  return savedSearches.find((search) => search.id === id)
}

export const getRecentSavedSearches = (limit = 2): SavedSearch[] => {
  return savedSearches.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).slice(0, limit)
}
